import styles from './Home.module.scss';

const publicUrl = process.env.PUBLIC_URL;

const pcImages = [
    `${publicUrl}/home/pc/home_1.gif`,
    `${publicUrl}/home/pc/home_2.gif`,
    `${publicUrl}/home/pc/home_3.gif`,
    `${publicUrl}/home/pc/home_4.gif`,
    `${publicUrl}/home/pc/home_5.gif`,
    `${publicUrl}/home/pc/home_6.gif`,
    `${publicUrl}/home/pc/home_7.gif`,
    `${publicUrl}/home/pc/home_8.gif`,
];

const mobileImages = [
    `${publicUrl}/home/mobile/home_1.jpg`,
    `${publicUrl}/home/mobile/home_2.jpg`,
    `${publicUrl}/home/mobile/home_3.jpg`,
    `${publicUrl}/home/mobile/home_4.jpg`,
    `${publicUrl}/home/mobile/home_5.jpg`,
    `${publicUrl}/home/mobile/home_6.jpg`,
];

const shurikenIcon = `${publicUrl}/shuriken.png`;

export default () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.pcOnly}>
                    {pcImages.map((image, index) => (
                        <div key={index} className={styles.slide}>
                            <img
                                src={image}
                                alt={`Home screen PC ${index + 1}`}
                                className={styles.homeImage}
                            />
                        </div>
                    ))}
                </div>
                <div className={styles.mobileOnly}>
                    {mobileImages.map((image, index) => (
                        <div key={index} className={styles.slide}>
                            <img
                                src={image}
                                alt={`Home screen Mobile ${index + 1}`}
                                className={styles.homeImage}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <a href="https://ms-base-rental.com/#/shuriken/design" target="_blank" rel="noopener noreferrer" className={styles.designButton}>
                <img src={shurikenIcon} alt="shuriken" className={styles.buttonIcon} />
                <span className={styles.buttonText}>デザインしてみよう</span>
            </a>
        </div>
    );
};
